import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'bg-black flex flex-col',
		wrapper: 'px-2 py-4 lg:px-4 lg:py-7 2xl:max-w-[172rem] 2xl:mx-auto',
		container: 'flex flex-col lg:grid lg:grid-cols-6 lg:gap-x-7 lg:grid-rows-[auto,minmax(0,1fr)]',
		charGrid: 'grid grid-cols-1 md:grid-cols-2 gap-1 lg:gap-2 col-span-3 row-span-2 mt-2 lg:mt-4',
		charBox: 'border border-onyx p-2 lg:p-3 rounded-s',
		figure: 'flex justify-center h-full col-span-3 row-span-3 mt-2 lg:mt-0',
		image: 'object-contain',
	},
})

export type CircularityVariants = VariantProps<typeof styles>
